const insertNodeAfter = (element, newNode) => element.parentNode.insertBefore(newNode, element);

export default insertNodeAfter;
